import React from "react";

// components
import TextInput from "../../../components/elements/form/TextInput";
import Button from "../../../components/elements/form/Button";

// state
import { shareDocument } from "../../../service/api/document";
import Modal from "../../../components/ui/modal";
import { useAppDispatch, useAppSelector } from "../../../store";
import { DocumentId } from "../../../store/@types/document";

type ISendFile = {
  document_id: DocumentId;
  visible: boolean;
  onSubmit: () => void;
};

const SendFIle = ({ document_id, visible, onSubmit }: ISendFile) => {
  const dispatch = useAppDispatch();
  const [email, emailSet] = React.useState("");
  const loading = useAppSelector(({ document }) => document.loading);

  const onSubmitRequest = async () => {
    if (email && document_id) {
      const response = await shareDocument(dispatch, {
        email,
        document_id,
      });
      if (response) {
        onSubmit?.();
      }
    }
  };

  return (
    <Modal
      open={visible}
      // onCancel={onSubmit}
      onClose={onSubmit}
    >
      <div className="space-y-6 mt-8 md:mt-0">
        <TextInput
          label=" Enter recipient Corporate Email"
          name="email"
          value={email}
          onChange={(e) => emailSet(e.target.value)}
          placeholder="Email"
          type="email"
          required
        />
        <Button
          title="Send"
          loading={loading}
          className="bg-primary-500 hover:bg-primary-900 rounded-lg text-white"
          onHandler={onSubmitRequest}
          rightIcon={null}
        />
      </div>
    </Modal>
  );
};

export default SendFIle;
